import { camelCaseify } from '~/utils'

export const pResponseSettings = (json) => {
  return camelCaseify(json)
}

export const pRequestSettings = (json) => {
  return json.replace(/([A-Z])/g, '_$1').toLowerCase()
}
